import { Subject } from 'rxjs';

// base implementation for refresh services
export class RefreshService {
  private refreshSubject = new Subject<void>();

  get refresh$() {
    return this.refreshSubject.asObservable();
  }

  triggerRefresh() {
    this.refreshSubject.next();
  }
}
